<template>
  <Card :title="$t('global.visual-comparison')" :height100="false">
    <div class="mb-4">{{ $t("global.visual-comparison-desc-1") }}</div>
    <div class="mb-4">{{ $t("global.visual-comparison-desc-2") }}</div>
    <a
      href="https://help.nexcess.net/74095-wordpress/how-to-use-visual-comparison-tool?from_search=53721961"
    >
      {{ $t("global.learn-more") }}
    </a>
  </Card>
</template>

<script>
import Card from "@/components/display/Card";

export default {
  name: "VisualComparisonNotice",
  components: {
    Card,
  },
};
</script>
